import { ROUTE_PARAMS } from 'constants/routeParamNames';

import { ROUTES_NEW_ROOT, ROUTES_ROOT } from './routesRoot';

// роуты для поисковой строки в браузере
export const WEB_ROUTES = {
  // лендинги
  loansSeoLanding: `${ROUTES_ROOT}/onlajn`,
  creditCardsSeoLanding: `${ROUTES_ROOT}/promo/karty`,
  // только для sravni.market
  marketplaceSeoLanding: ROUTES_ROOT,
  bezPoseshhenijaBanka: `${ROUTES_ROOT}/kredit_na-kartu-bez-poseshhenija-banka`,
  obrazovanie: `${ROUTES_ROOT}/kredit_na-obrazovanie`,
  iphonee: `${ROUTES_ROOT}/kredit_na-iphonee`,
  nalichnymi: `${ROUTES_ROOT}/kredit-nalichnymi`,
  loansRates: `${ROUTES_ROOT}/stavki-po-bankam`,

  // выдача
  loansOffers: `${ROUTES_ROOT}/podbor-onlajn`,

  // анкета
  creditForm: `${ROUTES_ROOT}/anketa`,

  // WL
  whiteLabel: `${ROUTES_ROOT}/onlajn-zayavka-na-kredit/wl`,
  whiteLabelNew: `${ROUTES_NEW_ROOT}/anketa/wl`,
  // Promo WL
  promoWl: `${ROUTES_NEW_ROOT}/onlajn-zayavka-na-kredit/wl`,
  partnerWl: `${ROUTES_NEW_ROOT}/onlajn-zayavka-na-kredit`,

  // MPL
  creditsFullDeal: `${ROUTES_ROOT}/full-deal`,
  completedDeal: `${ROUTES_ROOT}/full-deal/completed-deals/:${ROUTE_PARAMS.HASHED_DEAL_ID}`,

  // Restore User
  restoreUser: `${ROUTES_ROOT}/podbor-onlajn-v3/restore-user/:${ROUTE_PARAMS.RESTORE_GUID}`,

  // Wayback
  wayback: `${ROUTES_ROOT}/wayback/:${ROUTE_PARAMS.WAYBACK_GUID}`,
  waybackNew: `${ROUTES_NEW_ROOT}/wayback`,

  // фиды
  product: `${ROUTES_NEW_ROOT}/bank/:${ROUTE_PARAMS.BANK_ALIAS}/product/:${ROUTE_PARAMS.PRODUCT_ALIAS}`,
  productForm: `${ROUTES_NEW_ROOT}/product/anketa`,
  productStatus: `${ROUTES_NEW_ROOT}/product/status`,
} as const;
